<template>
  <div class="orderMsgCard">
    <slot name="card-name"></slot>
    <slot name="card-count"></slot>
  </div>
</template>

<script>
export default {
  name: 'orderMsgCard'
}
</script>

<style scoped>
  .orderMsgCard{
    width: 200px;
    height: 100px;
    border-radius: 15px;
  }
</style>
